import type { TestCaseDetailsProps } from './types'

export function TestCaseDetails({
  testCase,
  activeCaseId,
  getInputValue,
  updateInputValue,
  expectedValue,
  onExpectedChange,
  isOriginalCase,
  isInPlace,
}: TestCaseDetailsProps) {
  return (
    <form
      className="border-border/60 bg-muted/30 space-y-6 rounded-lg border p-4"
      aria-label="Test case inputs"
      onSubmit={(event) => event.preventDefault()}
    >
      <fieldset className="space-y-6">
        {isOriginalCase && testCase.testCaseIntent?.trim() ? (
          <section className="space-y-2">
            <h3 className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
              Intent
            </h3>
            <div className="overflow-x-auto">
              <p className="text-foreground text-sm leading-relaxed">
                {testCase.testCaseIntent}
              </p>
            </div>
          </section>
        ) : null}

        <section className="space-y-2">
          <h3 className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
            Input{testCase.inputs.length > 1 ? 's' : ''}
          </h3>
          {testCase.inputs.length ? (
            <dl className="space-y-3">
              {testCase.inputs.map((input) => (
                <div
                  key={`${activeCaseId ?? 'case'}-${input.name}`}
                  className="space-y-1"
                >
                  <dt className="text-foreground text-sm font-medium">
                    {input.name} =
                  </dt>
                  <dd>
                    <input
                      type="text"
                      value={getInputValue(activeCaseId, input.name)}
                      onChange={(event) =>
                        updateInputValue(
                          activeCaseId,
                          input.name,
                          event.target.value,
                        )
                      }
                      className="focus-visible:ring-ring h-9 w-full rounded-md border border-transparent bg-[#F2F3F4] px-3 py-2 font-mono text-xs text-black focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none dark:border-white/10 dark:bg-[#3C3C3C] dark:text-white"
                      spellCheck={false}
                      aria-label={`Input value for ${input.name}`}
                    />
                  </dd>
                </div>
              ))}
            </dl>
          ) : (
            <p className="text-muted-foreground text-sm italic">(none)</p>
          )}
        </section>

        {!isInPlace && (
          <section className="space-y-2">
            <h3 className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
              Expected Output
            </h3>
            <input
              type="text"
              value={expectedValue}
              onChange={(event) => onExpectedChange(event.target.value)}
              className="focus-visible:ring-ring h-9 w-full rounded-md border border-transparent bg-[#F2F3F4] px-3 py-2 font-mono text-xs text-black focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none dark:border-white/10 dark:bg-[#3C3C3C] dark:text-white"
              spellCheck={false}
              aria-label="Expected output value"
            />
          </section>
        )}
      </fieldset>
    </form>
  )
}
